import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const Terms = () => (
  <div className="min-h-screen">
    <Header />
    <main id="main-content" className="pt-24 pb-16 container mx-auto px-4 max-w-4xl">
      <h1 className="text-4xl font-bold mb-8">Website Terms of Use</h1>
      <div className="prose prose-lg text-muted-foreground space-y-6">
        <p><strong>Last updated:</strong> February 2026</p>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">About This Website</h2>
          <p>This website is owned and operated by:</p>
          <p>Coblynau IT Solutions</p>
          <p>By using this website, you agree to the terms set out below.</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">Website Content</h2>
          <p>
            The content on this website is provided for general information only. We make reasonable
            efforts to keep information accurate and up to date but do not guarantee that all content
            is complete or current.
          </p>
          <p>We reserve the right to update or change website content at any time.</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">Use of the Website</h2>
          <p>
            You agree to use this website only for lawful purposes and not in any way that may
            damage, disable, or interfere with the operation of the site.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">Enquiries and Communications</h2>
          <p>
            If you contact us through this website, you agree that the information you provide may
            be used to respond to your enquiry and provide our services.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">Data Protection</h2>
          <p>
            Any personal information submitted through this website is processed by Coblynau IT
            Solutions as the data controller.
          </p>
          <p>
            We are responsible for handling personal data in accordance with our{" "}
            <Link to="/privacy-policy" className="text-primary hover:underline">Privacy Policy</Link>.
          </p>
          <p>
            Our website may be supported by external website and hosting providers who process data
            on our behalf and only in accordance with applicable data protection laws.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">External Links</h2>
          <p>
            This website may include links to external websites. We are not responsible for the
            content or privacy practices of those sites.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">Liability</h2>
          <p>
            We do not accept liability for any loss or damage arising from the use of this website
            or reliance on its content, to the extent permitted by law.
          </p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">Governing Law</h2>
          <p>These terms are governed by the laws of England and Wales.</p>
        </section>

        <section>
          <h2 className="text-2xl font-semibold text-foreground mt-8">Contact</h2>
          <p>
            Questions about these terms? Contact us at{" "}
            <a href="mailto:info@coblynausolutions.co.uk" className="text-primary hover:underline">
              info@coblynausolutions.co.uk
            </a>
          </p>
        </section>
      </div>
    </main>
    <Footer />
  </div>
);

export default Terms;
